import AuditLogView from "../AuditLogView.vue";
import AuditLog from "../Pages/AuditLog.vue";

const routes = [
  {
    path: 'auditoria',
    component: AuditLogView,
    children: [
      {
        path: '',
        name: 'celulares-ad-audit-log',
        roles: ['auditoria_lista'],
        component: AuditLog
      },
    ]
  },
]

export default routes
